import { Layout } from '@components/Layout';
import PermissionGate from '@components/upercut-permissions/PermissionGate';
import SubscriptionPlansTable from '@modules/subscriptions/SubscriptionPlansTable';
import { Route, Routes } from 'react-router-dom';

const SubscriptionPlansPage = () => {
    return (
        <Layout
            breadcrumbs={[
                { label: 'Tableau de bord', href: '/', value: 'dashboard' },
                { label: "Plans d'abonnement", href: '/subscription-plans', value: 'subscription-plans' },
            ]}
            heading="Plans d'abonnement"
        >
            <Routes>
                <Route
                    path="/"
                    element={
                        <PermissionGate permission="subscriptions:read">
                            <SubscriptionPlansTable showTitle={false} />
                        </PermissionGate>
                    }
                />
            </Routes>
        </Layout>
    );
};

export default SubscriptionPlansPage;
